import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";

export interface GxTertiaryButtonProps {
  /** Click handler */
  onClick: () => void;

  /** Button text */
  children?: React.ReactNode;

  /** Loading state */
  loading?: boolean;

  /** Disabled state */
  disabled?: boolean;

  /** Button type */
  type?: "button" | "submit" | "reset";

  /** Custom label to show during loading state */
  loadingLabel?: string;
}
const GxSuspendButton: React.FC<GxTertiaryButtonProps> = ({
  onClick,
  children,
  loading = false,
  disabled = false,
  type = "button",
  loadingLabel,
}) => {
  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };

  const getButtonText = () => {
    if (loading) {
      return loadingLabel || children || "";
    }
    return children || "";
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || loading}
      type={type}
      className="gx-dialog-suspend-button gx-p12-eb"
    >
      {loading && (
        <Loader
          type="pulsing"
          themeColor="secondary"
          size="small"
          className="mr-2"
        />
      )}
      <span className="gx-p12-eb">{getButtonText()}</span>
    </Button>
  );
};

export default GxSuspendButton;
